<div class="toolbar">
  <q9-toolbar>
    <div q9-left-content>
      <q9-section *ngIf="refModel$ | async as refModel">
        <span title [title]="refModel.name | decodeHtml">{{ refModel.name | decodeHtml }}</span>

        <span content>
          <span *ngIf="refModel.description | decodeHtml">
            {{ refModel.description | decodeHtml }}&nbsp;
          </span>
          <span *ngIf="refModel.external">
            ({{ (orgInfo$ | async)?.isSandbox ? 'Sandbox' : 'Production' }})
          </span>
        </span>
      </q9-section>
    </div>

    <div q9-right-content>
      <ng-container *ngIf="showShareRefModelButton">
        <q9-primary-button (click)="onShareRefModel()">
          {{ 'CORE.USER_ACCESS.SHARE_BTN' | translate }}
        </q9-primary-button>
      </ng-container>
      <q9-theme-switcher></q9-theme-switcher>
      <q9-reports (reportAction)="showSavedReports($event)"></q9-reports>
      <q9-notifications></q9-notifications>
      <q9-profile-menu></q9-profile-menu>
    </div>
  </q9-toolbar>

  <q9-toolbar>
    <div q9-left-content>
      <button
        mat-button
        class="home-button"
        (click)="goToRefModelView()"
        [matTooltip]="'TOOLTIPS.BACK_TO_REFMODEL' | translate">
        <mat-icon inline="true" matPrefix svgIcon="elements_logo-icon"></mat-icon>
        {{ 'SEARCH.TOOLBAR_TITLE' | translate }}
      </button>

      <ng-container *ngIf="!isLoading">
        <mat-divider vertical="true"></mat-divider>

        <q9-section>
          <span title>{{title}}</span>
          <span content>{{subTitle}}</span>
        </q9-section>
      </ng-container>
    </div>

    <div q9-right-content *ngIf="!isLoading">
      <q9-icon-button
        icon="refresh"
        (click)="reloadGrid()"
        q9Track="TOOLTIPS.RELOAD"
        matTooltipPosition="below"
        matTooltip="{{ 'TOOLTIPS.RELOAD' | translate }}"></q9-icon-button>

      <q9-icon-button
        icon="filter-reset"
        (click)="resetFilters()"
        tooltipPosition="below"
        [tooltip]=" 'DEPENDENCY_TREE.GRID_RESET_FILTERS' | translate "
        [disabled]="!filters().length"></q9-icon-button>

      <q9-icon-button
        (click)="copyLink()"
        icon="share"
        tooltipPosition="below"
        [tooltip]=" 'CODE_SEARCH.SHARE_LINK_TOOLTIP' | translate"></q9-icon-button>
    </div>
  </q9-toolbar>
</div>

<q9-info-message type="error" *ngIf="errorMessage">
  Error: {{ errorMessage | translate }}
</q9-info-message>

<router-outlet *ngIf="!errorMessage"></router-outlet>
